import { render, staticRenderFns } from "./indexTotal.vue?vue&type=template&id=491df31f&scoped=true"
import script from "./indexTotal.vue?vue&type=script&lang=js"
export * from "./indexTotal.vue?vue&type=script&lang=js"
import style0 from "./indexTotal.vue?vue&type=style&index=0&id=491df31f&prod&lang=scss"
import style1 from "./indexTotal.vue?vue&type=style&index=1&id=491df31f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491df31f",
  null
  
)

export default component.exports